// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"f237bb0e","723":"442490ef"}[chunkId] + ".chunk.css";
};